import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType } from '@repo/ui/src/types/image';
import { Card, StyledToutContent, StyledScroller } from './styles';

export interface AccProps {
  accessories: Array<{
    toutContent?: any;
    img: {
      image: MediaType;
      altTag: string;
    };
  }>;
}

const AccessorySlider = ({ accessories }: AccProps) => {
  return (
    <StyledScroller display="flex" alignItems="stretch" white className="accessory-slider">
      {accessories &&
        accessories.map(({ img, toutContent }, i) => (
          <Card key={i} img={buildImageSrc(img.image, 700, 1, 1)} tabIndex={0}>
            <StyledToutContent
              dark
              headingStyleVariant="h5"
              divider={!!toutContent?.description}
              {...toutContent}
              buttonSize="small"
              align="left"
            />
          </Card>
        ))}
    </StyledScroller>
  );
};

export default AccessorySlider;
